/**
 * なる早を踏まえて、検証・保存に使う開始日を返す。
 * なる早 ON の間も入力済みの開始日はフォームに残し、OFF に戻したときに元の値へ戻せるようにしている。
 * そのため ON のときは残っている値を使わず null にする（なる早と開始日は排他）
 */
export function resolveEffectiveStartOn(startOn: string, isStartAsap: boolean): string | null {
  if (isStartAsap) return null
  return startOn || null
}
